import { render, staticRenderFns } from "./TicketDashboard.vue?vue&type=template&id=7ee76c0d&scoped=true&"
import script from "./TicketDashboard.vue?vue&type=script&lang=js&"
export * from "./TicketDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TicketDashboard.vue?vue&type=style&index=0&id=7ee76c0d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee76c0d",
  null
  
)

export default component.exports